// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-57dbdabb]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.tabs[data-v-57dbdabb] {\n  margin: 20px auto;\n}\n.tabs[data-v-57dbdabb] .ant-tabs-nav .ant-tabs-tab {\n  font-size: 16px;\n  font-weight: 400;\n}\n.tabs[data-v-57dbdabb] .ant-tabs-nav .ant-tabs-tab-active {\n  font-size: 16px;\n  font-weight: 500;\n}\n", ""]);
// Exports
module.exports = exports;
